import React from "react";
import Link from "theme/components/atoms/Typography/Link";
import { FormattedMessage } from "react-intl";
import Button from "theme/components/atoms/Button";
import FormActions from "theme/components/molecules/Form/FormActions";

const ProductAddedPopInActions = ({ hidePopin }) => {
  return (
    <FormActions appearance="center">
      <Button onClick={hidePopin}>
        <FormattedMessage
          id="modules.ProductAddedPopIn.continue"
          defaultMessage="Continue shopping"
        />
      </Button>
      <Link to="/cart" buttonAppearance="primary">
        <FormattedMessage
          id="modules.ProductAddedPopIn.seeCart"
          defaultMessage="Go to cart"
        />
      </Link>
    </FormActions>
  );
};

export default ProductAddedPopInActions;
